import { render, staticRenderFns } from "./CodVerificationOnboarding.vue?vue&type=template&id=517f8b40&scoped=true"
import script from "./CodVerificationOnboarding.vue?vue&type=script&lang=js"
export * from "./CodVerificationOnboarding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517f8b40",
  null
  
)

export default component.exports